import { ModalProps } from '@chakra-ui/react';
import InputText from '@/trio-ui/InputText';
import Modal from '@/trio-ui/Modal';
import * as Styles from './TechnicalDesignModal.styles';
import TextEditor from '../TextEditor';

type TechnicalDesignModalProps = Pick<ModalProps, 'onClose' | 'isOpen'> & {
  title: string;
  body: string;
  isEditing: boolean;
  isButtonDisabled?: boolean;
  onConfirmHandler?: () => void;
  onChangeBody?: (value: string) => void;
  onChangeTitle?: (value: string) => void;
};

export default function TechnicalDesignModal({
  isButtonDisabled,
  title,
  body,
  isEditing,
  isOpen,
  onClose,
  onConfirmHandler,
  onChangeBody,
  onChangeTitle,
}: TechnicalDesignModalProps): JSX.Element {
  const Body = (
    <Styles.Content>
      {isEditing ? 'Insert your Technical Design title and content below.' : ''}

      <Styles.TitleBox>
        {isEditing ? (
          <InputText
            name="technicalDesignTitle"
            value={title}
            onChangeHandler={(event) => (onChangeTitle ? onChangeTitle(event.target.value) : {})}
            placeholder="Your title here..."
          />
        ) : (
          <Styles.Title>{title}</Styles.Title>
        )}
      </Styles.TitleBox>
      <TextEditor
        value={body}
        onChangeText={onChangeBody}
        isEditing={isEditing}
        hideButtons
        hideEditButton
      />
    </Styles.Content>
  );

  return (
    <Modal
      isButtonDisabled={isButtonDisabled}
      modalId="technical-design-modal"
      isCentered
      size="4xl"
      modalTitle="Technical Design"
      bodyRender={Body}
      isOpen={isOpen}
      onClose={onClose}
      onConfirmLabel="Save"
      onConfirmClick={onConfirmHandler}
      hideCancelButton={!isEditing}
      hideConfirmButton={!isEditing}
    />
  );
}
